<div class="rs-flex-row">
  <div class="rs-flex-columns small-12">
    <div class="panel rs-bg-grey3">
      <h4 class="rs-tit5">{{ 'cybercare.claim.title' | translate }}</h4>
      <p>
        {{ 'cybercare.claim.description' | translate }}
      </p>
      <div class="rs-flex-row">
        <div class="rs-flex-columns small-12 medium-6">
          <div class="rs-panel-flex">
            <div class="rs-panel-flex-cell rs-bg-c2">
              <h5 class="rs-tit6">{{ 'cybercare.claim.template.title' | translate }}</h5>
              <p [innerHTML]="'cybercare.claim.template.description' | translate: true"></p>
              <a
                data-tms-event="link-click"
                data-tms-link-zone="cyber care"
                attr.data-tms-link-name="{{ 'cybercare.claim.template.link.label' | translate }}"
                href="{{ 'cybercare.claim.template.link.url' | translate }}"
                class="rs-btn rs-btn-third"
                target="_blank"
                data-cy="cybercareTemplateButton"
              >
                {{ 'cybercare.claim.template.link.label' | translate }}
                <i
                  class="rs-icon-btn-third rs-margin-left1"
                  title="{{ 'cybercare.claim.template.link.accessibility' | translate }}"
                >
                  <span class="show-for-sr">{{
                    'cybercare.claim.template.link.accessibility' | translate
                  }}</span>
                </i>
              </a>
            </div>
          </div>
        </div>
        <div class="rs-flex-columns small-12 medium-6">
          <div class="rs-panel-flex">
            <div class="rs-panel-flex-cell rs-bg-c2">
              <h5 class="rs-tit6">{{ 'cybercare.claim.contact.title' | translate }}</h5>
              <p [innerHTML]="'cybercare.claim.contact.description' | translate: true"></p>
              <a
                data-tms-event="link-click"
                data-tms-link-zone="cyber care"
                attr.data-tms-link-name="{{ 'cybercare.claim.contact.link.label' | translate }}"
                href="{{ 'cybercare.claim.contact.link.url' | translate }}"
                class="rs-btn rs-btn-third"
                target="_blank"
                data-cy="cybercareBrokerButton"
              >
                {{ 'cybercare.claim.contact.link.label' | translate }}
                <i
                  class="rs-icon-btn-third rs-margin-left1"
                  title="{{ 'cybercare.claim.contact.link.accessibility' | translate }}"
                >
                  <span class="show-for-sr"
                    >{{ 'cybercare.claim.contact.link.accessibility' | translate }}
                  </span>
                </i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
